import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
export function AppRouter() {
  return <ErrorBoundary data-id="element-23">
      <BrowserRouter data-id="element-24">
        <Routes data-id="element-25">
          <Route path="/" element={<App data-id="element-27" />} data-id="element-26" />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>;
}